import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { Spinner } from "@chakra-ui/react";

import signin_stock_rb_1_logo from "assets/images/logos/signin_page/signin_stock_rb_1_logo.png";
import signin_stock_rb_2_logo from "assets/images/logos/signin_page/signin_stock_rb_2_logo.png";

import forms_ui_element from "assets/images/ui_elements/forms_ui_element.png";
import useDocumentTitle from "hooks/useDocumentTitle";

import { GetVerifyTokenOnboarding } from "services/TokenService";

function Onboarding() {
  useDocumentTitle("Verify Token");

  const { token } = useParams();

  const [errorText, setErrorText] = useState("");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const leVerifyTokenOnboarding = async () => {
      try {
        setLoading(true);

        const resp = await GetVerifyTokenOnboarding({ token: token });

        if (resp.status === 200) {
          navigate("/verify_token_onboarding/set_pass/" + token);
        }
      } catch (error) {
        console.log(error);

        if (error.response) {
          if (error.response.status === 400) {
            setErrorText(
              "Token is invalid or expired. Please contact admin for assistance"
            );
          }

          if (error.response.status === 500) {
            setErrorText("Server error. Please contact admin for assistance");

            return;
          }
        }
      } finally {
        setLoading(false);
      }
    };

    leVerifyTokenOnboarding();
  }, []);

  return (
    <>
      <div className="sign-in-main-container">
        <div className="signin-left-panel-ts     ">
          <div className=" h-full flex flex-row justify-center  ">
            <div className="flex flex-col justify-center   ">
              <div className=" flex flex-col gap-8    ">
                <img
                  src={signin_stock_rb_1_logo}
                  className=" mx-auto w-16 h-16  "
                  alt="logo"
                />
                <img
                  src={signin_stock_rb_2_logo}
                  className=" mx-auto w-[11.7rem] h-[3.7rem] "
                  alt="logo"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="signin-right-layout-panel z-20   ">
          <div className="    signin-right-container-tc ">
            <div className="  lg:pr-52  ">
              <div className="mb-12">
                {loading && (
                  <>
                    <h1 className="pt-2 pl-2 ">
                      Hang On! We are verifying your account
                    </h1>
                    <div className=" mt-8 flex flex-row justify-center gap-4">
                      <Spinner size="xl" />
                    </div>
                  </>
                )}

                {setErrorText && (
                  <>
                    <h1 className="pt-2 pl-2 ">{errorText}</h1>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        src={forms_ui_element}
        className="absolute bottom-0 right-0  h-[30vh]  z-0    "
        alt="forms_ui_element"
      />
    </>
  );
}

export default Onboarding;
